var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

_.extend(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

_.extend(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

_.extend(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();

//# sourceMappingURL=data:application/json;base64,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
